import React from 'react';
import './VisibleBotMark.css';
import {getBotMarkIconPath} from '../../utils/bots/getBotMarkIconPath';
import {getVisibleBotTitle} from '../../utils/bots/getVisibleBotTitle';
import {getBotMarkAlt} from '../../utils/bots/getBotMarkAlt';

/**
 * Значок «это бот» в правом нижнем углу иконки фракции — для «явных» ботов
 * рейтинговых матчей (см. src/configs/visibleRankedBots.js) и для ботов
 * локальной партии (см. checkIfBotMarkShown). Вид значка зависит от лиги бота,
 * а у локального — от выбранного для него бонуса (см. getBotMarkIconPath). В
 * отличие от обычных ботов сетевых игр, такие показываются ботами ВСЕМ
 * игрокам: и в самом матче, и в деталях сыгранного матча, и в реплее.
 *
 * Тот же значок, но с иконкой ИИ и своей подписью, получает ИИ-игрок
 * промо-матча «Битва с AI» (isAi) — на тех же местах, что и явный бот.
 *
 * Позиционируется абсолютно, поэтому обертка иконки обязана иметь position —
 * см. .player-faction-icon-container, .player-info_faction-icon-container и
 * .game-end-player-icon. Исключение — список игроков лобби: там значок стоит
 * в строке справа от никнейма (LobbyPlayerName, .lobby-player-bot-mark).
 * Для строки текста (Зал славы, торжество победителя) — AiPlayerMark.
 */
const VisibleBotMark = ({className = '', player}) => (
  <img
    className={`visible-bot-mark ${className}`.trim()}
    src={getBotMarkIconPath(player)}
    alt={getBotMarkAlt(player)}
    // Лига (или уровень бонуса) и его расшифровка — теми же строками, что и
    // подсказка выбора бонуса в локальной игре; у ИИ — какая модель играет
    title={getVisibleBotTitle(player)}
  />
);

export default VisibleBotMark;
